module.exports = __webpack_public_path__ + "assets/img/enterIcon6.7b568f4a.png";